import {BluechatDelivery} from './bluechat-delivery.model';

export class BluechatLoad {

  public loadNumber: string;
  public status: BluechatLoadStatus;
  public blueyonderCarrierCode: string;
  public carrierId?: string;
  public carrierName: string;
  public deliveries: Array<BluechatDelivery>;
  public deliveriesCount: number;
  public bluechatCarrierCode: string;
  public vehicle: string;
  public stopNumber: number;
  public weight: string;
  public pieces: number;
  public totalDistance: number;
  public lastStopLatestFromDeliveryDateTime: string;
  public lastStopEarliestToDeliveryDateTime: string;


  public static fromDto(bluechatLoadDto: any): BluechatLoad {
    if (!bluechatLoadDto) {
      return null;
    }

    const bluechatLoad = new BluechatLoad();
    bluechatLoad.loadNumber = bluechatLoadDto.loadNumber;
    bluechatLoad.status = BluechatLoadStatus[bluechatLoadDto.status];
    bluechatLoad.blueyonderCarrierCode = bluechatLoadDto.blueyonderCarrierCode;
    bluechatLoad.carrierId = bluechatLoadDto.carrierId;
    bluechatLoad.carrierName = bluechatLoadDto.carrierName;
    bluechatLoad.deliveries          = bluechatLoadDto.deliveries.map(bluechatDelivery => BluechatDelivery.fromDto(bluechatDelivery));
    bluechatLoad.deliveriesCount     = bluechatLoadDto.deliveriesCount;
    bluechatLoad.bluechatCarrierCode = bluechatLoadDto.bluechatCarrierCode;
    bluechatLoad.vehicle = bluechatLoadDto.vehicle;
    bluechatLoad.stopNumber = bluechatLoadDto.stopNumber;
    bluechatLoad.weight = bluechatLoadDto.weight;
    bluechatLoad.pieces = bluechatLoadDto.pieces;
    bluechatLoad.totalDistance = bluechatLoadDto.totalDistance;
    bluechatLoad.lastStopEarliestToDeliveryDateTime = bluechatLoadDto.lastStopEarliestToDeliveryDateTime;
    bluechatLoad.lastStopLatestFromDeliveryDateTime = bluechatLoadDto.lastStopLatestFromDeliveryDateTime;
    return bluechatLoad;
  }
}

export enum BluechatLoadStatus {
  NULL = 'NULL',
  OPEN = 'OPEN',
  PLANNED = 'PLANNED',
  TENDERED = 'TENDERED',
  TENDER_REJECTED = 'TENDER_REJECTED',
  TENDER_ACCEPTED = 'TENDER_ACCEPTED',
  LOADING_CONFIRMING = 'LOADING_CONFIRMING',
  LOADED_CONFIRMED = 'LOADED_CONFIRMED',
  IN_TRANSIT = 'IN_TRANSIT',
  STOPPED = 'STOPPED',
  COMPLETED = 'COMPLETED',
  CLOSED = 'CLOSED',
  CANCELLED = 'CANCELLED',
}
